import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {AddItemThumbnail} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-thumbnail';
import type {ReplaceRowThumbnailStyling, ReplaceSourceOption} from '@Components/media-source-menu/media-source-menu.types';
import {AI_CONTENT_CLASS} from '@Components/media-source-menu/media-source-menu.types';

/** Maps flat replace rows onto the compact list style the dropdown and right-click surfaces render. */
export const toReplaceDropdownListItems = (options: ReplaceSourceOption[]): ControlledListItemType[] => {
  return options.map((option): ControlledListItemType => {
    return {
      id: option.id,
      icon: option.icon,
      text: option.text,
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
      isSelected: false,
      iconClasses: option.isAi ? AI_CONTENT_CLASS : '',
      textClasses: option.isAi ? AI_CONTENT_CLASS : '',
      onClick: option.onSelect,
    };
  });
};

/** Maps flat replace rows onto the roomier thumbnail + sub-text style the panels and item popup render. */
export const toReplaceThumbnailListItems = (options: ReplaceSourceOption[], styling: ReplaceRowThumbnailStyling): ControlledListItemType[] => {
  return options.map((option): ControlledListItemType => {
    return {
      id: option.id,
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
      text: option.text,
      subText: option.subText,
      textClasses: option.isAi ? AI_CONTENT_CLASS : '',
      onClick: option.onSelect,
      thumbnail: {
        type: ThumbnailType.CUSTOM,
        content: <AddItemThumbnail className={styling.thumbnailClasses} iconClassName={option.isAi ? AI_CONTENT_CLASS : styling.iconClasses} icon={option.icon} />,
      },
    };
  });
};
